RivalIQ.apps.Discovery.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.DiscoveryCollection = Backbone.Collection.mixin({

        mixins: {
            FetchByPostMixin: RivalIQ.utils.FetchByPostMixin
        },

        initialize: function (models, options) {
            const me = this;
            me.channel = options.channel;
        },

        url: function () {
            const me = this;
            const channel = me.channel;
            return `/api/accounts/${RivalIQ.state.account.get('id')}/discovery/${channel}/data`;
        }
    });
});
